import { IndustryTemplate } from '@/components';
import { windowCleaningContent } from '@/data/industries/window-cleaning';

export function WindowCleaningPage() {
  return <IndustryTemplate content={windowCleaningContent} />;
}
